<script>
import moment from "moment";

export default {
  name: "DataPicker",
  props: {
    paramsType: String,
    startPlaceholder: {
      type: String,
      default: "开始日期"
    },
    endPlaceholder: {
      type: String,
      default: "结束日期"
    }
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      timeValue: []
    };
  },
  methods: {
    dateChange(dataArr) {
      let arr = [];
      let fristTime = null;
      let lastTime = null;
      if (dataArr) {
        fristTime = moment(dataArr[0]).format("YYYY-MM-DD") + " 00:00:00";
        lastTime = moment(dataArr[1]).format("YYYY-MM-DD") + " 23:59:59";
      }
      if (fristTime) {
        arr.push(moment(fristTime).unix() + "000");
      }
      if (lastTime) {
        arr.push(moment(lastTime).unix() + "000");
      }
      this.$emit("valueFunc", this.paramsType, arr);
    }
  }
};
</script>

<template>
  <div style="width: 400px;margin-right: 8px;">
    <el-date-picker
      v-model="timeValue"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      :start-placeholder="startPlaceholder"
      :end-placeholder="endPlaceholder"
      :picker-options="pickerOptions"
      @change="dateChange"
      style="width: 100%;"
    >
    </el-date-picker>
  </div>
</template>

<style scoped lang="scss"></style>
